module.exports = __webpack_public_path__ + "img/img_commodity02_Shopping.1efa5fd6.png";